import { NgModule } from '@angular/core';
import { FormModelsModule } from 'src/shared/form-models/form-models.module';
import { RouterModule } from '@angular/router';
import { PrevailingWageModule } from 'src/admin-app/shared/prevailing-wage/prevailing-wage.module';
import { PurchaseOrderDetailsModule } from 'src/admin-app/shared/purchase-order-details/purchase-order-details.module';
import { OptionalJobFieldsModule } from 'src/admin-app/shared/optional-fields/optional-fields.module';
import { DocumentsModule } from 'src/shared/documents/documents.module';
import { QuoteReportDialogComponent } from './quote-report-dialog/quote-report-dialog.component';
import { QuoteDetailComponent } from './quote-detail.component';
import { QuoteDetailGeneralInfoComponent } from './general-info/general-info.component';
import { SharedGlobalModule } from 'src/shared/shared-global.module';
import { JobLocationModule } from 'src/shared/job-location/job-location.module';
import { BillingDetailsModule } from 'src/shared/billing-details/billing-details.module';
import { RailProsCommonModule } from 'src/admin-app/shared/railpros-common.module';
import { CommonUiModule } from 'src/shared/common-ui/common-ui.module';
import { DateTimeModule } from 'src/shared/date-time/date-time.module';
import { AlertsModule } from 'src/shared/alerts/alerts.module';
import { QuoteLogTableModule } from 'src/shared/quote-log-table/quote-log-table.module';
import { MultiChipInputModule } from 'src/shared/multi-chip-input/multi-chip-input.module';

@NgModule({
    imports: [
        RailProsCommonModule,
        RouterModule,
        FormModelsModule,
        JobLocationModule,
        PrevailingWageModule,
        BillingDetailsModule,
        PurchaseOrderDetailsModule,
        OptionalJobFieldsModule,
        DocumentsModule,
        AlertsModule,
        CommonUiModule,
        SharedGlobalModule,
        MultiChipInputModule,
        DateTimeModule,
        QuoteLogTableModule,
    ],
    declarations: [
        QuoteReportDialogComponent,
        QuoteDetailComponent,
        QuoteDetailGeneralInfoComponent,
    ]
})
export class QuoteDetailModule {}
